import { useEffect, useState } from 'react'
import { serverNow } from '@/shared/api/http'

/**
 * Сколько осталось до `deadline`, в секундах. Ноль — время вышло.
 *
 * Считает от ЧАСОВ СЕРВЕРА (см. serverNow в api/client), а не от часов
 * устройства. Разница в несколько минут — обычное дело на телефонах,
 * и с ней таймер показал бы «время вышло» на живой заявке. Покупатель
 * в этот момент просто закрывает страницу.
 *
 * И отдельно: ноль на таймере НЕ означает, что заявка истекла.
 * Истечение объявляет сервер, а страница лишь перестаёт обещать время.
 * Локальные часы права закрывать заявку не имеют.
 */
export function useCountdown(deadline: string): number {
  const target = Date.parse(deadline)

  const [left, setLeft] = useState(() => remaining(target))

  useEffect(() => {
    setLeft(remaining(target))
    const id = window.setInterval(() => setLeft(remaining(target)), 1_000)
    return () => window.clearInterval(id)
  }, [target])

  return left
}

function remaining(target: number): number {
  if (Number.isNaN(target)) return 0
  return Math.max(0, Math.floor((target - serverNow()) / 1000))
}

/**
 * «59 мин 32 сек» — словами, как в макете.
 *
 * Не «59:32»: двоеточие на платёжной странице читается как время суток,
 * а человеку надо понять, сколько у него осталось. Секунды показываем
 * всегда — они и создают ощущение уходящего времени.
 */
export function formatLeft(seconds: number): string {
  if (seconds >= 3600) {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    return `${hours} ч ${minutes} мин`
  }
  const minutes = Math.floor(seconds / 60)
  const rest = seconds % 60
  return `${minutes} мин ${String(rest).padStart(2, '0')} сек`
}
